import React, { useState } from 'react';
import { useFieldArray } from "react-hook-form";

const MediaStorageEditor = ({ mediaStorage, msIndex, unregister, deleteMediaStorage, register, control }) => {
    const namePrefix = "media_storages[" + msIndex + "]";
    const { fields, append, remove } = useFieldArray({
        control,
        name: namePrefix + "[excluded_directories]"
    });

    const addExDir = (e) => {
        e.preventDefault();
        append("");
    };

    const deleteExDir = (e, index) => {
        e.preventDefault();
        remove(index);
    };

    const extDirsRender = !fields || fields.length === 0
        ? "Исключенных директорий нет"
        : fields.map((field, index) => {
            const nn = namePrefix + "[excluded_directories][" + index + "]";
            return (
                <div className="d-flex exdir" key={field.id}>
                    <input {...register(nn)} className="form-control" />
                    <button type="button" onClick={(e) => deleteExDir(e, index)} className="btn trash-btn">
                        <em className="fa fa-trash-o"></em>
                    </button>
                </div>
            );
          });

    return (
        <div className="dirItem" key={mediaStorage.id}>
            <button type="button" onClick={(e) => deleteMediaStorage(e, msIndex)} className="btn trash-btn">
                <em className="fa fa-trash-o"></em>
            </button>
            <div className="row">
                <div className="col-lg-6">
                    <label>Локальный путь</label>
                    <input
                        role="presentation"
                        {...register(namePrefix + "[path]")}
                        className="form-control"
                        placeholder="/var/media/"
                    />
                </div>
                <div className="col-lg-6">
                    <label>Префикс в S3 <span>(необязательно)</span></label>
                    <input
                        role="presentation"
                        {...register(namePrefix + "[s3_prefix]")}
                        className="form-control"
                        placeholder="media/backup"
                    />
                </div>
            </div>
            <div className="mt-4">
                <div className="d-flex">
                    <h5>Исключить директории</h5>
                    <button type="button" onClick={(e) => addExDir(e)} className="btn btn-secondary ms-3">
                        <em className="fa fa-plus"></em>
                    </button>
                </div>
                <div>{extDirsRender}</div>
            </div>
        </div>
    );
};

export default MediaStorageEditor;
